export class EmptyApiResponse {
    constructor(error) {
        this.error = error;
    }
}
export class ApiResponse extends EmptyApiResponse {
}
